// extracted by mini-css-extract-plugin
module.exports = {"banner":"SellMyCarBanner_banner__KUgxf","title":"SellMyCarBanner_title__Dpau6","image":"SellMyCarBanner_image__6kYB9","button":"SellMyCarBanner_button__ukS0Q"};